import ErrorAlert from "@/utility/ErrorAlert";
import http from "../axios/http-common";

async function getDiagnosis() {
  const response = await http
    .getData("/referensi/askeb/diagnosis")
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response;
}

async function getIntervensi() {
  const response = await http
    .getData("/referensi/askeb/intervensi")
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response;
}

export default {
  getDiagnosis,
  getIntervensi
};
